<section class="summary-heading__section" >
	<div id="imgContainer" ngClass.xs="text--center">
		<img *ngIf="logoPath" [alt]="logoAltTag" [src]="logoPath" />
	</div>
	<div id="nameContainer" class="h3" data-cy="summary-heading__firstName_lastName">
		{{ customer?.first_name }} {{ customer?.last_name }}
	</div>
	<div class="confirmation-wrapper">
		<div class="confirmationContainer">
			<div class="text--start">{{ 'summary.confirmationnumber' | locale }}</div>
			<div class="text--end font--bold" data-cy="summary-heading__confirmation-number--orderNumber">
				{{ orderNumber }}
			</div>
		</div>
		<div class="confirmationContainer" *ngIf="primaryPayment || alternatePayment">
			<div class="text--start">{{ 'summary.primarypayment' | locale }}</div>
			<div class="text--end font--bold" data-cy="summary-heading__primaryPayment--ccType_last4">
				<ng-container *ngIf="primaryPayment; else showAlternatePayment">
					{{ 'card.' + primaryPayment.type | locale }} {{ primaryPayment.last_four }}
				</ng-container>
				<ng-template #showAlternatePayment>
					{{ 'summary.alternatepayment_' + alternatePayment | locale }}
				</ng-template>
			</div>
		</div>
		<div class="purchase-timestamp" *ngIf="purchaseTimestamp">
			<div class="text--start">{{ 'summary.purchased' | locale }}</div>
			<div class="text--end font--bold purchase-date" data-cy="summary-heading__purchaseTimestamp">
				{{ purchaseTimestamp | date: 'short' }}
			</div>
		</div>
	</div>
</section>
